import { toFixed } from '@/util/Parsers'
import formatStudyData from '@/formatters/formatStudyData'
import formatUnits from '@/formatters/formatUnits'
import formatCurrency from '@/formatters/formatCurrency'
import formatNumber from '@/formatters/formatNumber'
import dayjs from 'dayjs'
import { formatDate, parsejurisdictionAsFullText } from '@/util/Helpers'

export default {
  methods: {

    formatNumber(number) {
      return formatNumber(number)
    },
    toFixed(value, precision = 2) {
      return toFixed(value, precision)
    },
    formatDate(args) {
      return formatDate(args)
    },
    formatDateTimestamp({timestamp, format = 'MM/DD/YYYY', lang = 'en'}) {
      if (!timestamp) return ''
      dayjs.locale(lang)
      return dayjs.unix(timestamp).format(format)
    },
    formatDateTime({date, format = 'MM/DD/YYYY HH:mm:ss', from = 'YYYY-MM-DD HH:mm:ss', lang = 'en'}) {
      if (!date) return ''
      dayjs.locale(lang)
      return dayjs(date, from).format(format)
    },
    formatStudyData(col, value, data) {
      return formatStudyData(col, value, data)
    },
    formatCurrency(value) {
      return formatCurrency(value)
    },
    formatUnits(value) {
      if(value == null) return '--'
      return formatUnits(value)
    },
    parsejurisdictionAsFullText(jurisdiction, capitalize = false) {
      return parsejurisdictionAsFullText(jurisdiction, capitalize)
    }
  },
}

